import { Calendar, Video } from "lucide-react";
import Reveal from "./Reveal";
import CtaButton from "./CtaButton";
import RegisterButton from "./RegisterButton";

const FinalCTA = () => (
    <section data-testid="final-cta-section" className="relative py-24 md:py-32">
        <div className="relative mx-auto max-w-6xl px-4 sm:px-6">
            <div
                data-testid="final-cta-card"
                className="neon-section relative overflow-hidden rounded-[2.5rem] bg-white/[0.02] px-6 py-16 text-center md:px-12 md:py-24"
            >
                <div className="pointer-events-none absolute -left-32 bottom-0 h-[420px] w-[420px] rounded-full bg-electric/20 blur-3xl" />
                <div className="pointer-events-none absolute -right-32 top-0 h-[420px] w-[420px] rounded-full bg-neon/20 blur-3xl" />
                <svg
                    viewBox="0 0 80 48"
                    aria-hidden="true"
                    className="pointer-events-none absolute left-1/2 top-1/2 h-[260px] -translate-x-1/2 -translate-y-1/2 opacity-[0.05]"
                >
                    <rect x="6" y="16" width="8" height="18" rx="2" fill="#D9A8FF" />
                    <rect x="26" y="10" width="8" height="26" rx="2" fill="#A020F0" />
                    <rect x="46" y="4" width="10" height="36" rx="2" fill="#C84DFF" />
                    <rect x="66" y="12" width="8" height="20" rx="2" fill="#D9A8FF" />
                </svg>

                <Reveal>
                    <div className="relative flex flex-wrap items-center justify-center gap-3">
                        <span className="inline-flex items-center gap-2 rounded-full border border-neon/40 bg-neon/10 px-4 py-1.5">
                            <Calendar size={13} className="text-lav" />
                            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-lav">
                                Every Monday &amp; Tuesday
                            </span>
                        </span>
                        <span className="inline-flex items-center gap-2 rounded-full border border-neon/40 bg-neon/10 px-4 py-1.5">
                            <Video size={13} className="text-lav" />
                            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-lav">
                                Live via Zoom
                            </span>
                        </span>
                    </div>
                    <h2 className="mx-auto mt-8 max-w-3xl font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl md:text-7xl">
                        READY TO LEARN{" "}
                        <span className="text-duo-grad">ENGULFING?</span>
                    </h2>
                    <p className="mx-auto mt-6 max-w-2xl leading-relaxed text-white/70">
                        Mulakan perjalanan pembelajaran trading anda dengan
                        memahami teknik Engulfing bersama komuniti Queen of
                        Dollars.
                    </p>
                </Reveal>

                <Reveal delay={0.12}>
                    <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row sm:flex-wrap">
                        <CtaButton location="Final" testId="final-cta-button">
                            PM Admin to Join
                        </CtaButton>
                        <RegisterButton testId="final-register-button" />
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);

export default FinalCTA;
